export const ELECTRICAL_SHEATH_TYPE_TITLE = 'claim.declaration.external_damages.form.electrical_sheath.title';
